module.exports = __webpack_public_path__ + "img/premium_slideimage01.335add0e.jpg";